import React from 'react';

import { makeStyles, useTheme } from '@material-ui/core/styles';

import { Icon } from '@hydra/common/components';

const ICON_TYPES = {
  solvability: 'gear',
  importance: 'impact',
  rating: 'star'
};

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(0.5),
    display: 'inline-block'
  }
}));

interface RatingIcons {
  rating: number;
  max?: number;
  type: 'solvability' | 'importance' | 'rating',
  emptyColor?: string;
  fillColor?: string;
  size: string;
  key?: string;
}

export default function RatingIcons (props: RatingIcons) {
  const classes = useStyles();
  const theme = useTheme();
  const {
    rating = 0,
    max = 3,
    type = 'solvability',
    size = 'md',
    fillColor = theme.palette.primary.main,
    emptyColor = theme.palette.primary.light
  } = props;

  const iconType = ICON_TYPES[type] || ICON_TYPES.solvability;

  const icons = Array.from({ length: max })
    .map((_, i) => {
      return (
        <div key={i} className={classes.icon}>
          <Icon
            type={iconType}
            color={i < rating ? fillColor : emptyColor}
            size={size}
          />
        </div>
      );
    });

  return (
    <>
      {icons}
    </>
  );
}
